import { defineComponent, computed } from "vue";
import { getConfig } from "./component-library2.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "square-badge",
  props: {
    text: null,
    footnoteText: { default: void 0 },
    footnoteClass: { default: void 0 },
    green: { type: Boolean },
    magenta: { type: Boolean },
    black: { type: Boolean },
    white: { type: Boolean },
    yellow: { type: Boolean }
  },
  emits: ["click"],
  setup(__props, { emit }) {
    const props = __props;
    const className = computed(() => {
      const list = [];
      if (props.black)
        list.push("square-badge--black");
      if (props.green)
        list.push("square-badge--green");
      if (props.magenta)
        list.push("square-badge--magenta");
      if (props.white)
        list.push("square-badge--white");
      if (props.yellow)
        list.push("square-badge--yellow");
      if (props.footnoteText)
        list.push("square-badge--button");
      return list;
    });
    const openModal = () => {
      const globalModal = getConfig().globalModal || void 0;
      if (!(globalModal == null ? void 0 : globalModal.openModal))
        return;
      globalModal.openModal({
        content: props.footnoteText,
        className: props.footnoteClass
      });
    };
    const handleClick = (e) => {
      if (props.footnoteText) {
        e.preventDefault();
        openModal();
      } else {
        emit("click", e);
      }
    };
    return { __sfc: true, props, emit, className, openModal, handleClick };
  }
});
export {
  _sfc_main as default
};
